import { Suspense } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { ARTICLE_REGISTRY } from './article-registry'

export const useCtaUrl = (base = '/support') => {
  const { search } = useLocation()
  return search ? `${base}${search}` : base
}

export const ArticlePage = () => {
  const { slug } = useParams()
  const ArticleComponent = ARTICLE_REGISTRY[slug]

  if (!ArticleComponent) return <Navigate to="/" replace />

  return (
    <Suspense fallback={
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 16 }}>
        <CircularProgress color="primary" />
      </Box>
    }>
      <ArticleComponent />
    </Suspense>
  )
}
